const AMAZON_URL = 'https://www.amazon.co.jp/dp/B0G117GHSW'
const RAKUTEN_URL = 'https://item.rakuten.co.jp/mixiofficial/mdp01-j/'
const SOLD_OUT_TEXT = 'ご好評につき完売いたしました'
const AMAZON_SALE_TEXT = '今だけ10%OFF'

export type PurchaseChannel = 'amazon' | 'rakuten'

export interface PurchaseChannelStateInput {
  amazonAvailable: boolean
  rakutenAvailable: boolean
  isAmazonSaleActive: boolean
}

export interface PurchaseChannelDisplayState {
  channel: PurchaseChannel
  href: string
  label: string
  isPrimary: boolean
  subText?: string
}

export function buildPurchaseChannelDisplayStates({
  amazonAvailable,
  rakutenAvailable,
  isAmazonSaleActive,
}: PurchaseChannelStateInput): PurchaseChannelDisplayState[] {
  return [
    {
      channel: 'amazon',
      href: AMAZON_URL,
      label: 'Amazonで購入',
      isPrimary: amazonAvailable,
      subText: amazonAvailable ? (isAmazonSaleActive ? AMAZON_SALE_TEXT : undefined) : SOLD_OUT_TEXT,
    },
    {
      channel: 'rakuten',
      href: RAKUTEN_URL,
      label: '楽天市場で購入',
      isPrimary: !amazonAvailable && rakutenAvailable,
      subText: rakutenAvailable ? undefined : SOLD_OUT_TEXT,
    },
  ]
}
